import { keyframes } from 'styled-components';
export const slideFromTop = keyframes`
  from { transform: translateY(-100%); }
  to { transform: translateY(0%); }
`;
export const slideFromBottom = keyframes`
  from { transform: translateY(100%);}
  to { transform: translateY(0); }
`;
export const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;
export const scaleUpCenter = keyframes`
  from { opacity: 0.5; -webkit-transform: scale(0.5); transform: scale(0.5); }
  to { opacity: 1; -webkit-transform: scale(0.5); transform: scale(1); }
`;